/**
 * Settings tabs contributed by Intelligent Assistants (Beta-1 plan P4-01, §1c: universal settings
 * vs each IA's own tab). An IA appears here only when it is active in `assistants.js` (and, for
 * HUGO, when its feature flag is on) — so the tab row grows as IAs ship.
 */
import React from 'react';
import { ASSISTANTS } from '../../assistants/assistants.js';
import { FEATURE_HUGO } from '../../config/features.js';
import OrgSettings from '../../assistants/drew/pages/OrgSettings.jsx';

const TAB_COMPONENTS = {
  drew: () => <OrgSettings section="drew" embedded />,
};

const FLAGS = { hugo: () => FEATURE_HUGO };

export function assistantSettingsTabs() {
  return ASSISTANTS.filter((a) => a.active && TAB_COMPONENTS[a.id] && (!FLAGS[a.id] || FLAGS[a.id]()))
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
    .map((a) => ({ key: a.id, label: a.name, avatar: a.avatarSmall || a.avatar, Component: TAB_COMPONENTS[a.id] }));
}
